const settingsConstants = {
  textLogoWhiteUrl: '/images/app-logo.png',
}

export default settingsConstants
